<div class="custom-tab-wrapper my-4">
  <div class="custom-tab-buttons">
    <button [ngClass]="{ active: selectedTab === 0 }" (click)="selectedTab = 0">
      Unprocessed
    </button>
  </div>

  <div class="custom-tab-content">
    <ng-container [ngSwitch]="selectedTab">
      <app-expiration-date-adoption-date-unprocessed
        *ngSwitchCase="0"
      ></app-expiration-date-adoption-date-unprocessed>
    </ng-container>
  </div>
</div>
